var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('uc-modal', {
    ref: "otpModelRef",
    attrs: {
      "closable": true,
      "is-full-screen": _vm.$vuetify.breakpoint.xsOnly,
      "persistent": true,
      "modal-card-props": {
        headerText: _vm.headerText,
        size: 'lg'
      }
    },
    on: {
      "click:close": function ($event) {
        return _vm.resetValues();
      }
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex flex-column align-center justify-center"
        }, [_c('uc-text', {
          staticClass: "mb-4",
          attrs: {
            "text": "Enter OTP",
            "type": "body",
            "size": 1,
            "bold": false
          }
        }), _c('onboard-shared-otp-input', {
          ref: "otpRef",
          staticStyle: {
            "max-width": "400px"
          },
          attrs: {
            "input-mode": "numeric",
            "size": 'small'
          },
          on: {
            "complete": function ($event) {
              return _vm.validateOtp($event);
            },
            "onChange": function ($event) {
              return _vm.onChangeOtp($event);
            }
          }
        }), _vm.errorMessages ? _c('div', {
          staticClass: "d-flex mt-2 flex-row align-center"
        }, [_c('uc-icon', {
          attrs: {
            "value": _vm.ALERT,
            "size": 'md',
            "state": 'error'
          }
        }), _c('uc-text', {
          attrs: {
            "text": _vm.errorMessages,
            "type": "body",
            "size": 1,
            "bold": false,
            "palette-color": "error"
          }
        })], 1) : _vm._e(), _c('div', {
          staticClass: "d-flex flex-row align-center mt-2"
        }, [_c('uc-text', {
          attrs: {
            "text": "Didn't receive a code?",
            "type": "body",
            "size": 2,
            "bold": false
          }
        }), _c('uc-button', {
          attrs: {
            "text": `Resend ${_vm.timerEnable ? 'in ' + _vm.timerCount + ' seconds' : ''}`,
            "type": "text",
            "size": "md",
            "disabled": _vm.timerEnable
          },
          on: {
            "click": function ($event) {
              var _vm$otpRef;
              (_vm$otpRef = _vm.otpRef) === null || _vm$otpRef === void 0 ? void 0 : _vm$otpRef.resetOtp();
              _vm.$emit('resend-otp-action');
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };